import { render, staticRenderFns } from "./ImageGalery.vue?vue&type=template&id=475599e2&scoped=true&lang=pug"
import script from "./ImageGalery.vue?vue&type=script&lang=js"
export * from "./ImageGalery.vue?vue&type=script&lang=js"
import style0 from "./ImageGalery.vue?vue&type=style&index=0&id=475599e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475599e2",
  null
  
)

export default component.exports